import axios from 'axios';

export const selfRegister = (credentials) => {
  return axios({
    url: `/registerMe`,
    method: 'POST',
    data: credentials,
    headers: {
      'content-type': 'application/json'
    }
  });

};

// Submits POST data for authentication of user.
export const authenticate = (credentials) => {
  const { userName, password } = credentials;
  const initialState = JSON.parse(window.sessionStorage.getItem('initialState'));
  const signinAT = window.sessionStorage.getItem('signinAT');
  const creds = {
    username: userName,
    password
  };
  const data = {
    initialState,
    signinAT,
    credentials: creds,
  }

  return axios.request({
    url: `/authenticate`,
    method: 'POST',
    data
  }).then(response => {

    if (initialState && signinAT) {

      const { authnToken, tenantName, user_access_token } = response.data;

      let myform = document.createElement("form");
      myform.method = "POST";
      myform.action = `https://${tenantName}.identity.oraclecloud.com/sso/v1/sdk/session`;
      myform.target = "_top";
      let authnTokenInput = document.createElement('input');
      authnTokenInput.name = 'authnToken';
      authnTokenInput.value = authnToken;
      authnTokenInput.hidden=true;
      myform.appendChild(authnTokenInput);
      document.body.appendChild(myform);
      //adding this to flush session after successful login...
      window.sessionStorage.clear();
      window.sessionStorage.setItem('idcsToken', user_access_token)

      window.localStorage.removeItem(userName);
      return myform.submit();
    } else {
      return response;
    }
  });
}

export const getMyProfile = (token) => {
  return axios.request({
    url: `/myProfile`,
    method: 'GET',
    headers: {
      'access-token': token
    }
  });
};

export const updateProfile = (credentials, token) => {
  return axios.request({
    url: `/updateProfile`,
    method: 'POST',
    data: credentials,
    headers: {
      'access-token': token
    }
  })
}

export const resetPassword = (userName, appName) => {
  return axios.request({
    url: `/resetPassword/`,
    method: 'POST',
    data: {
        userName: userName,
        appName: appName
    },
    headers: {
      'content-type': 'application/json'
    }
  });
}

export const resetPasswordConfirmation = (userName, appName) => {
    return axios.request({
        url: `/resetPasswordConfirmation/`,
        method: 'POST',
        data: {
            userName: userName,
            appName: appName
        },
        headers: {
            'content-type': 'application/json'
        }
    });
}

export const setNewPassword = (password, token) => {
  return axios.request({
    url: `/setNewPassword/`,
    method: 'POST',
    data: {
      password,
      token
    }
  });
}

export const changePassword = (oldPassword, password, token) => {
  return axios.request({
    url: `/changePassword/`,
    method: 'POST',
    data: {
      oldPassword,
      password,
      token
    },
    headers: {
      'access-token': token
    }
  });
}

export const activateAccount = (token) => {
  return axios.request({
    url: `/activateAccount/`,
    method: 'POST',
    headers: {
      'access-token': token
    }
  });
}

export const resetUserEmail = (userName) => {
    return axios.request({
        url: `/resetUserEmail`,
        method: 'POST',
        data: {
            "userName": userName
        }
    });
}

export const reactivateAccount = (userName) => {
  return axios.request({
    url: `/reactivateAccount/`,
    method: 'POST',
    data: {
      userName
    }
  });
}

export const forgotUsername = (props) => {
  let email = props.email;
  return axios.request({
    url: `/forgotUsername`,
    method: 'POST',
    params: {
	  "email":email,
    }
  });
}

export const sendUsername = (credentials) => {
    let userName = credentials.userName;
    let appName = credentials.appName;
    return axios.request({
        url: `/sendUsername`,
        method: 'POST',
        data: {
            "userName": userName,
            "appName": appName
        }
    });
}

export const accountLocked = (userName, appName) => {
    return axios.request({
        url: `/accountLocked`,
        method: 'POST',
        data: {
            "userName": userName,
            "appName": appName
        }
    });
}

export const checkProvisioning = (userName) => {
    var idcsToken = "";
    if (sessionStorage.getItem('idcsToken') !== undefined) {
        idcsToken = sessionStorage.getItem('idcsToken');
    }
  return axios.request({
    url: '/getUser/',
    method: 'POST',
    data: {
        userName,
        idcsToken
    }
  })
}

export const hasCompany = (userName) => {
    return axios.request({
        url: '/hasCompany/',
        method: 'POST',
        data: {
            userName
        }
    })
}

export const userStatus = (userName) => {
    return axios.request({
        url: '/userStatus/',
        method: 'POST',
        data: {
            userName
        }
    })
}

export const removeFromGroup = (userName, groupName) => {
  return axios.request({
    url: '/removeFromGroup/',
    method: 'POST',
    data: {
      userName,
        groupName
    }
  })
}

export const logout = () => {
    return axios.request({
        url: '/logout/',
        method: 'GET'
    })
}

export const appUrls = (appName) => {
    return axios.request({
        url: '/appUrls/',
        method: 'POST',
        data: {
            appName
        }
    })
}